import { render, staticRenderFns } from "./HomeworkDo.vue?vue&type=template&id=2bbf0e08&scoped=true&"
import script from "./HomeworkDo.vue?vue&type=script&lang=js&"
export * from "./HomeworkDo.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkDo.vue?vue&type=style&index=0&id=2bbf0e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf0e08",
  null
  
)

export default component.exports